/*

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/Login";
import MainLayout from "./components/layout/MainLayout";
import { routes } from "./routes";
import ProtectedRoute from "./pages/ProtectedRoute";

const App = () => {
  return (
   <BrowserRouter>
  <Routes>
    { Página inicial -> vai direto para MainLayout }
    <Route path="/" element={<Navigate to="/MainLayout" />} />

    { Acesso direto ao MainLayout sem proteção }
    <Route path="/MainLayout" element={<MainLayout />}>
      {routes}
    </Route>

    { Rota coringa }
    <Route path="*" element={<Navigate to="/MainLayout" />} />
  </Routes>
</BrowserRouter>

  );
};

export default App;
*/

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/Login";
import MainLayout from "./components/layout/MainLayout";
import { routes } from "./routes";
import ProtectedRoute from "./pages/ProtectedRoute";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Tela inicial = login */}
        <Route path="/" element={<LoginPage />} />

        {/* MainLayout protegido */}
        <Route
          path="/MainLayout"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          {routes}
        </Route>

        {/* Qualquer rota inválida volta para login */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;